// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"53ccc5ab","856":"16e361c1","951":"8d89adac"}[chunkId] + ".js";
};